import React from 'react';
import clsx from 'clsx';
import { v4 as uuid } from 'uuid';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { HeroHalfV5 } from 'types/studio/studio';
import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './HeroHalfV5Benefits.module.scss';

type Props = Pick<HeroHalfV5, 'benefitsList' | 'benefitsAlignToStart'> & {
  visibleOnPageLoad: boolean;
  isDarkMode: boolean;
};

const HeroHalfV5Benefits = ({
  benefitsList,
  benefitsAlignToStart,
  visibleOnPageLoad,
  isDarkMode
}: Props) => (
  <div className={clsx(benefitsList && benefitsList.length < 4 && styles.compactListContainer)}>
    <div
      className={clsx(
        benefitsList && benefitsList.length < 4 && styles.compactList,
        styles.benefitsList,
        getThemeCSSClass('new')
      )}>
      {benefitsList?.map((item) => (
        <div
          key={uuid()}
          className={clsx(styles.benefitItem, { [styles.alignToStart]: benefitsAlignToStart })}>
          {item.icon && (
            <StudioBaseIconV2
              icon={item.icon}
              className={styles.benefitIcon}
              eagerLoading={visibleOnPageLoad}
            />
          )}
          <Typography
            component="div"
            variant="caption"
            size="1"
            weight="400"
            noPadding
            className={clsx(styles.benefitText, isDarkMode && styles.isDarkMode)}
            color={getTypographyDefaultColor('new')}>
            <CustomPortableText value={item.text} />
          </Typography>
        </div>
      ))}
    </div>
  </div>
);

export default HeroHalfV5Benefits;
